import { z } from "zod";

export const PurchaseInvoiceParams = z.object({
    page: z.number().default(1),
    pageSize: z.number().default(10),
    supplierID: z.string().optional(),
    open_supplier_picker: z.boolean().optional(),
})